import React from 'react';
import Link from 'next/link';

import styles from '../pure.module.css';

export type FavoriteLocation = {
  title: string;
  url: string;
};

type FavoriteLocationSectionProps = {
  favoriteLocations: FavoriteLocation[];
};

export default function FavoriteLocationsSection({
  favoriteLocations,
}: FavoriteLocationSectionProps) {
  return (
    <div
      id="favorite-locations-section"
      className="flex flex-col gap-7 px-4 py-16 d:mt-20 d:px-0 d:gap-11 d:ml-122 d:py-0"
    >
      <h1 className="text-2xl d:text-32 text-rp-neutral">Favorite locations</h1>
      <div className="flex gap-4 d:max-w-827 flex-wrap w-full">
        {favoriteLocations.map((locations, index) => (
          <React.Fragment key={`item-${index.toString()}`}>
            <Link href={locations.url}>
              <a
                className={`text-rp-primary-redesign text-32 d:text-5xl underline ${styles['underline-offset-9']}`}
              >
                {locations.title}
              </a>
            </Link>
            {index !== favoriteLocations.length - 1 && (
              <span className="text-rp-cloud text-32 d:text-5xl">/</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
